<template>
    <div class="toast-container position-fixed bottom-0 end-0 p-3">
        <ProgressToast v-for="toast in toasts" :titulo="toast.title" :body="toast.body" :started_at="toast.started_at"></ProgressToast>
    </div>
</template>
<script setup lang="ts">

import { computed } from 'vue';
import ProgressToast from './ProgressToast.vue';
import { processando } from '@/store/arquivos';


const toasts = computed(() => {
    let rows: { title: string, body: string, started_at: Date}[] = [];
    for (let row of processando.value.values()) {

        let progresso = row.lines === 0 ? 0 : Math.round(row.line * 100 / row.lines)
        
        rows.push({
            title: row.tipo,
            body: `${row.status}: ${progresso}% (${row.line}/${row.lines})`,
            started_at: new Date(row.created_at)
        })
    }
    return rows
})


</script>